import type { Ceviri } from "../tip";
import type { grafik as tr } from "../tr/grafik";

const gun = (n: number) => (n === 1 ? "day" : "days");

/** English dictionary · grafik. */
export const grafik: Ceviri<typeof tr> = {
  baslik: "Daily Analysis",
  aciklama: "The portfolio day by day — each point is the same figure as that day's report.",
  paraBirimi: "Currency",
  gorunum: "View",
  tutarlar: "Amounts",
  getiriYuzdesi: "Return %",
  tutarlarBaslik: (para) => `Amounts (${para})`,

  tarih: {
    baslik: "Date range",
    ikiTarih: "Choose both dates.",
    sira: "The start date cannot be after the end date.",
    enCokGun: (n) => `The range can be at most ${n} ${gun(n)}.`,
  },
  gecmisKilidi: (yil) => `Price history older than ${yil} ${yil === 1 ? "year" : "years"}`,
  gecmisKilidiAciklama: "Move the start to a more recent day.",
  guncelleniyor: "Updating with new prices…",
  bosBaslik: "Nothing to value in this range",
  bosAciklama: "The vault holds no assets and no return-bearing transactions on these dates.",
  hesaplaniyor: (biten, toplam) => `Calculating: ${biten} / ${toplam} ${gun(toplam)}`,

  alan: {
    value: "Total assets",
    cost: "Total cost",
    unrealizedGain: "Current return",
    unrealizedGainRatio: "Current return %",
    totalReturn: "Lifetime return",
    totalReturnRatio: "Lifetime return %",
  },

  seciliGun: "Selected day",
  bayatGun: "This day's value rests on a stale measurement.",
  bayatOlcum: "stale measurement",
  motorSoylemedi: "The engine did not say why this value is missing — this is a defect, please report it.",

  cizgi: {
    cizgiler: (baslik) => `${baslik}: lines`,
    svgGun: (baslik, n) => `${baslik} — ${n} ${gun(n)}`,
    svgGorunen: (n) => `, ${n} ${gun(n)} shown`,
    svgYardim: ". Arrow keys pick the selected day; to zoom use +, −, 0 or drag with the mouse.",
  },

  yakinlastirma: {
    grup: (baslik) => `${baslik}: zoom`,
    yakinlas: "Zoom in",
    yakinlasBalon: "Zoom in (+) — or drag on the chart to select a range",
    uzaklas: "Zoom out",
    uzaklasBalon: "Zoom out (−)",
    tumunu: "Show all",
    tumunuBalon: "Show all (0)",
    tumu: "All",
  },

  aralik: {
    tumTarihler: "All dates",
    ozel: "Custom range",
    donem: "Period",
    baslangic: "Start",
    bitis: "End",
  },

  donem: {
    bugun: "Today",
    dun: "Yesterday",
    buHafta: "This week",
    son1Hafta: "Last 1 week",
    gecenHafta: "Previous week",
    buAy: "This month",
    son1Ay: "Last 1 month",
    gecenAy: "Previous month",
    son2Ay: "Last 2 months",
    buCeyrek: "This quarter",
    son3Ay: "Last 3 months",
    oncekiCeyrek: "Previous quarter",
    buYariyil: "This half-year",
    son6Ay: "Last 6 months",
    gecenYariyil: "Previous half-year",
    buYil: "This year",
    son1Yil: "Last 1 year",
    gecenYil: "Previous year",
    son2Yil: "Last 2 years",
    son3Yil: "Last 3 years",
    son4Yil: "Last 4 years",
    son5Yil: "Last 5 years",
    son10Yil: "Last 10 years",
  },


  kars: {
    butunKasa: "Whole vault",
    sanal: (ad) => `${ad} (virtual)`,
    sanalTemettuHaric: (ad) => `${ad} (virtual, dividends excluded)`,
    karsilastirilan: "Compared",
    baslik: (ad) => `Comparison: ${ad}`,
  },

  olcu: {
    baslik: "Measures",
    aciklama:
      "Time-weighted: deposits and withdrawals are not counted as return. Volatility is annualised (√365). " +
      "Measures against the risk-free rate will come with the deposit series.",
    kiyas: "Benchmark",
    kiyasYok: "No benchmark",
    altin: "Gold (oz)",
    dolar: "US dollar",
    euro: "Euro",
    motorSebep: "The engine did not give a reason.",
    kismi: " (partial)",
    hesaplaniyor: "Calculating measures…",
    hata: (mesaj) => `Measures could not be calculated: ${mesaj}`,
    hesap: "Account",
    getiri: "Return",
    enBuyukDusus: "Max drawdown",
    enIyiYil: "Best year",
    enKotuYil: "Worst year",
    enIyiAy: "Best month",
    enKotuAy: "Worst month",
    oynaklik: "Volatility",
    kiyasaFark: "Vs benchmark",
    derlemedeYok: "No measures in this build.",
    toparlanmadi: "not recovered",
    toparlandi: (tarih) => `recovered ${tarih}`,
    kiyasEtiket: "benchmark",
  },
};
